// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Quotation_wrapper__19Wh1","inView":"Quotation_inView__1L3Ke","content":"Quotation_content__RFgyS","small":"Quotation_small__35l3J","author":"Quotation_author__AwnSw"};